// For each set that is being checked out, we store the trays locally in memory
import { atom, useAtom } from 'jotai';
// And then send them to the server once all trays have been inspected
import { DeliveryId } from 'api/models/Deliveries';

export type CheckOutTray = {
  trayInstanceId: string;
  name: string;
  imageDataUri?: string;
  gsImagePath?: string;
  // set as soon as the image is captured so the upload can run in the background; awaited (with a
  // fallback re-upload) when the set is saved, instead of blocking on it at capture time
  uploadPromise?: Promise<void>;
  allDevicesCleanOfDebris?: boolean;
  allDevicesFunctional?: boolean;
  allDevicesInTray?: boolean;
  missingParts?: string[];
  missingPartsComment?: string;
  trayUsed?: boolean;
  comments?: string;
  completed?: boolean;
  trayReference?: number;
};

export type CheckOutTrays = {
  [trayInstanceId: string]: CheckOutTray;
};

export type CheckOutTraysBySet = {
  [setKitInstanceId: string]: {
    turnaroundDeliveryId?: DeliveryId;
    trays: CheckOutTrays;
  };
};

export const checkOutTraysBySetAtom = atom<CheckOutTraysBySet>({});

export const useCheckOutTraysBySet = () => useAtom(checkOutTraysBySetAtom);
